/**
 * @generated SignedSource<<0356cddf49c43808a63d3edc7944b2ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizViewerFilters_participativeModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookmarkedFilter_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "4af39b3e206ac9dcd345a0c4a072c47d";

module.exports = node;
